<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <Settings
        v-bind:region="'left'"
        v-bind:title="resource('TemplatePageSettings_Settings_Title')"
        v-bind:tooltip="tooltip"
        class="page-settings"
    >
        <template v-slot:body
        >
            <settings-slider
                v-bind:label="resource('TemplateManager_Shared_Width_Label')"
                v-bind:value="width"
                v-bind:min="290"
                v-bind:max="950"
                v-bind:value-suffix="'px'"
                @input="$emit('change-width', $event)"
            >
            </settings-slider>
            
            <settings-media-picker
                class="form-group"

                v-bind:media-id="mediaId"
                v-bind:label="resource('TemplateManager_Shared_BackgroundMediaId_Label')"
                @file-picked="setBackground($event)"
            >
                <template v-slot:browse-button-right>
                    <i
                       v-if="hasImage"
                       class="fas fa-lg fa-trash-alt mdb-icon-btn delete float-right mt-2" 
                       aria-hidden="true" 
                       @click.stop="promptRemoveBackground">
                    </i>
                </template>
            </settings-media-picker>
            
            <settings-media-cropper
                class="form-group"

                v-if="hasImage"
                v-bind:label="resource('TemplateManager_Shared_OpenMediaCropper_Button_Text')"
                v-bind:media-id="mediaId"

                @image-cropped="imageCropped($event.mediaId, $event.crop)"
            >
            </settings-media-cropper>
            
            <settings-color-picker
                v-bind:label="resource('TemplateManager_Shared_BackgroundColor_Label')"
                v-bind:value="color"
                @input="$emit('change-color', $event)"
            >
            </settings-color-picker>
            
            <settings-slider
                v-bind:label="resource('TemplatePageSettings_Margin_Label')"
                v-bind:value="margin"
                v-bind:min="1"
                v-bind:max="250"
                v-bind:value-suffix="'px'"
                @input="$emit('change-margin', $event)"
            >
            </settings-slider>
        </template>
    </Settings>
</template>

<script>
    import {pageSettingsTooltip} from "../../tooltips";

    import {promptV2 as prompt} from "../../../../Util/prompt";
    
    import resourceMixin from "../../../../Util/Mixins/resources";

    import SettingsMediaPicker from "./SettingsMediaPicker.vue";
    import SettingsMediaCropper from "./SettingsMediaCropper.vue";
    import SettingsSlider from "./SettingsSlider.vue";
    import SettingsColorPicker from "./SettingsColorPicker.vue";
    import Settings from './Settings.vue';

    export default {
        name: "template-settings",
        mixins: [resourceMixin],
        components: {
            SettingsMediaPicker,
            SettingsMediaCropper,
            SettingsSlider,
            SettingsColorPicker,
            Settings
        },
        computed: {
            hasImage(){
                const vm = this;
                
                return !!vm.mediaId;
            }
        },
        methods: {
            promptRemoveBackground(){
                const vm = this;
                
                if(!vm.hasImage) return;

                prompt(
                    vm.resource('TemplateManager_Shared_RemoveBackgroundPrompt_Title'), 
                    vm.resource('TemplateManager_Shared_RemoveBackgroundPrompt_Body')
                ).then(
                    () => vm.setBackground(null),
                    () => { /*Do nothing */ }
                );
            },
            imageCropped(id, crop){
                const vm = this;
                
                vm.setBackground(id);
                vm.$emit('change-crop', crop);
            },
            setBackground(id){
                const vm = this;
                
                vm.$emit('change-image', id);
            }
        },
        data: () => ({tooltip: pageSettingsTooltip}),
        props: {
            width: {
                type: Number,
                required: true
            },
            mediaId: {
                type: String,
                required: false
            },
            color: {
                type: String,
                required: false
            },
            margin: {
                type: Number,
                required: true
            }
        }
    };
</script>
